import axios from 'axios'
import { host } from '../../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {
     data: []
    }
}
//types
const OBTENER_DATOS_MAGUEY_HISTORICO_EXITO= 'OBTENER_DATOS_MAGUEY_HISTORICO_EXITO'
const AGREGAR_DATOS_MAGUEY_HISTORICO_EXITO= 'AGREGAR_DATOS_MAGUEY__HISTORICO_EXITO'
const ACTUALIZAR_DATOS_MAGUEY_HISTORICO_EXITO= 'ACTUALIZAR_DATOS_MAGUEY_HISTORICO_EXITO'
const OBTENER_REGISTRO_MAGUEY_BY_ASOCIADO_EXITO = 'OBTENER_REGISTRO_MAGUEY_BY_ASOCIADO_EXITO'

export const obtenerAllDatosMagueyHistorico = createAsyncThunk(
    OBTENER_DATOS_MAGUEY_HISTORICO_EXITO,
    async (iddatosmaguey) => {
        try {
           
            const fullUrl = host + `DatosMagueyHistorico/obtenerAllDatosMagueyHistorico/${iddatosmaguey}`
            const res = await axios.get(fullUrl)
          
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerRegistroMagueyByAsociado = createAsyncThunk(
    OBTENER_REGISTRO_MAGUEY_BY_ASOCIADO_EXITO,

    async (data) => {
        
        try {
            const fullUrl = host + `RegistroPredio/obtenerRegistroMagueyByAsociado/${data}`
          
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarDatosMagueyHistorico = createAsyncThunk(
    AGREGAR_DATOS_MAGUEY_HISTORICO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DatosMagueyHistorico/agregarDatosMagueyHistorico`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizarDatosMagueyHistorico = createAsyncThunk(
    ACTUALIZAR_DATOS_MAGUEY_HISTORICO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DatosMagueyHistorico/actualizarDatosMagueyHistorico`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)



export const datMagueyH = createSlice({
    name: 'datMagueyH',
    initialState: dataInicial,
    reducers: {
       
    },
    extraReducers: {
      
        [obtenerAllDatosMagueyHistorico.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            console.log(state.data);
        },
        [agregarDatosMagueyHistorico.fulfilled]: (state, { payload }) => {
         
        },

        [actualizarDatosMagueyHistorico.fulfilled]: (state, { payload }) => {
       
        },

        [obtenerRegistroMagueyByAsociado.fulfilled]: (state, { payload }) => {
        
            state.data = payload.data
        },
    },
})

export const {
} = datMagueyH.actions
export const DatosMagueyHistoricoReducerUsuarioAgricola = datMagueyH.reducer